import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { NgIconsModule } from '@ng-icons/core';
import * as phosphorIconsRegular from '@ng-icons/phosphor-icons/regular';
import * as phosphorIconsFill from '@ng-icons/phosphor-icons/fill';
import * as heroIconsOutline from '@ng-icons/heroicons/outline';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { unauthorizedInterceptor } from './interceptors/unauthorized-interceptor';
import { apiInterceptor } from './interceptors/api-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        unauthorizedInterceptor,
        apiInterceptor
      ])
    ),
    provideAnimations(),
    importProvidersFrom(NgIconsModule.withIcons(phosphorIconsRegular as any)),
    importProvidersFrom(NgIconsModule.withIcons(phosphorIconsFill as any)),
    importProvidersFrom(NgIconsModule.withIcons(heroIconsOutline as any))
  ]
};
